import { render, staticRenderFns } from "./info-identification.vue?vue&type=template&id=0eff26ae&scoped=true&"
import script from "./info-identification.vue?vue&type=script&lang=js&"
export * from "./info-identification.vue?vue&type=script&lang=js&"
import style0 from "./info-identification.vue?vue&type=style&index=0&id=0eff26ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eff26ae",
  null
  
)

export default component.exports